import React from 'react';
import PresentationTitleImg from '../components/presentationTitleImg';

const Competence = ({ title, text, img }) => (
  <PresentationTitleImg title={title} text={text} img={img} />
);

export default Competence;



// WEBPACK FOOTER //
// ./src/app/pages/competence.jsx